export const LOGIN_PATHNAME = "/login";
export const LOGIN_CALLBACK_PATHNAME = "/login/callback";
